import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { SiteRouteParams } from '../core/routeparams';

@Injectable()
export class RedirectGuard {
  canActivate(route: ActivatedRouteSnapshot): boolean {
    const siteId = (route.params as SiteRouteParams).siteId;
    window.location.replace(route.data['redirectUrl'] + siteId);
    return true;
  }
}
